import { TReportType } from 'contexts/app-context/types'

export enum TipoRelatorio {
  TRATAMENTO_DADOS = 'TRATAMENTO_DADOS',
  COMPARTILHAMENTO = 'COMPARTILHAMENTO',
  PORTABILIDADE = 'PORTABILIDADE',
  ACESSO = 'ACESSO_DADOS',
}

export const REPORT_DICTIONARY: Record<TReportType, TipoRelatorio> = {
  DATA_ACCESS: TipoRelatorio.ACESSO,
  DATA_PORTABILITY: TipoRelatorio.PORTABILIDADE,
  DATA_SHARING: TipoRelatorio.COMPARTILHAMENTO,
  DATA_TREATMENT: TipoRelatorio.TRATAMENTO_DADOS,
}

type RelatorioOrigem = 'PF' | 'PJ'

export interface Relatorio {
  cpf: string
  dataSolicitacao: string
  dataAlteracao: string
  trackNumber: string
  tipoSolicitacao: TipoRelatorio
  status: RelatorioStatus
  origem: RelatorioOrigem
}

export type RelatorioStatus =
  | 'EM_ANALISE'
  | 'DADOS_NAO_ENCONTRADOS'
  | 'ERRO_EXECUCAO'
  | 'ERRO_NAO_PERTURBE'
  | 'CONCLUIDA'
  | 'COMPLETA'
  | 'FECHADA'
  | 'LIBERADA'
  | 'AGUARDANDO_EXECUCAO'
  | 'BLACKLIST'
  | 'BLOQUEADO'
  | 'NAO_BLOQUEADO'

export interface GetReportsHistoryResponse {
  historicoRelatorioSolicitacoes: Relatorio[]
}

export interface RequestReportStatusResponse {
  status: RelatorioStatus
  dataSolicitacao?: string
}
